import { render, staticRenderFns } from "./xiuxianhuodong.vue?vue&type=template&id=e6023764&scoped=true"
import script from "./xiuxianhuodong.vue?vue&type=script&lang=js"
export * from "./xiuxianhuodong.vue?vue&type=script&lang=js"
import style0 from "./xiuxianhuodong.vue?vue&type=style&index=0&id=e6023764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6023764",
  null
  
)

export default component.exports